import { ReactElement } from 'react';
import { DocumentIcon } from '@heroicons/react/24/outline';
import { LinearLoader } from './LinearLoader';
import { getFileSizeInMb } from '../util/getFileSizeInMb';
import type { FileToUploadInputType } from './UploadButton';

interface Props {
  uploading: FileToUploadInputType[];
  Icon?: HeroIconType;
}

export const FileUploadProgress = ({
  uploading,
  Icon = DocumentIcon,
}: Props): ReactElement | null => {
  if (!uploading.length) return null;

  return (
    <div className="flex flex-col space-y-2">
      {uploading.map((u) => (
        <div key={u.uuid}>
          <div className="text-body-smallest mb-2 py-2 flex space-x-2">
            <Icon className="size-5 text-grey-400 shrink-0" />
            <div className="grow space-x-2 truncate">
              <span>{u.file.name}</span>
              <span>•</span>
              <span>{getFileSizeInMb(u.file.size)}</span>
            </div>
            <span className="text-body-smallest text-text-subtle">
              {Math.round(u.progress * 100)}%
            </span>
          </div>
          <LinearLoader
            variant="determinate"
            backgroundColor="bg-grey-300"
            containerBackgroundColor="bg-grey-t-800"
            value={u.progress * 100}
          />
        </div>
      ))}
    </div>
  );
};
